const PATH = '/api/studio-uniform-catalogue';

async function request(method = 'GET', body = null) {
  const response = await fetch(PATH, {
    method,
    credentials: 'same-origin',
    cache: 'no-store',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.error || payload?.message || `Shared uniform service returned ${response.status}`);
  return payload;
}

export function loadSharedUniformCatalogue() {
  return request('GET');
}

export function addSharedUniformDefinitions(definitions) {
  if (!definitions || !Object.keys(definitions).length) return Promise.resolve({ ok: true, definitions: {}, mapping: {} });
  return request('PUT', { definitions });
}
